import { createContext, useContext, useState } from "react";

const ConnectorsContextApi = createContext();
const useConnectorsContext = () => useContext(ConnectorsContextApi);
const ConnectorsContext = ({ children }) => {
  const [selectedConnector, setSelectedConnector] = useState({
    id: ""
  });
  return (
    <ConnectorsContextApi.Provider
      value={{
        selectedConnector,
        setSelectedConnector
      }}
    >
      {children}
    </ConnectorsContextApi.Provider>
  );
};
export default ConnectorsContext;
export { useConnectorsContext };
